import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "summary-sidebar" };
const _hoisted_2 = { class: "pa-4 bg-primary" };
const _hoisted_3 = { class: "text-h6 text-white font-weight-medium" };
const _hoisted_4 = {
    key: 0,
    class: "d-flex justify-center py-8"
};
const _hoisted_5 = {
    key: 1,
    class: "pa-4"
};
const _hoisted_6 = { key: 2 };
const _hoisted_7 = { class: "pa-4 border-b" };
const _hoisted_8 = { class: "d-flex justify-space-between align-center mb-2" };
const _hoisted_9 = { class: "d-flex justify-space-between align-center" };
import { ref, onMounted } from "vue";
import { useStore } from "@/store";
import { useAuthStore } from "@/stores/auth";
import { dserverApi } from "@/services/dserverApi";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SummaryInfo',
    emits: ["start-search"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const store = useStore();
        const auth = useAuthStore();
        const summary_info = ref(null);
        const loading = ref(true);
        const errored = ref(false);
        async function load_summary() {
            errored.value = false;
            loading.value = true;
            const username = auth.username;
            if (!username) {
                errored.value = true;
                loading.value = false;
                return;
            }
            try {
                summary_info.value = await dserverApi.getUserSummary(username);
            }
            catch (error) {
                console.log(error);
                errored.value = true;
            }
            finally {
                loading.value = false;
            }
        }
        function searchDatasets() {
            store.current_pageNumber = 1;
            emit("start-search");
        }
        function clearFilters() {
            store.clearAll();
            store.current_pageNumber = 1;
            emit("start-search");
        }
        function toggleTag(tag) {
            store.updateTags(store.tags.includes(tag)
                ? store.tags.filter((t) => t !== tag)
                : [...store.tags, tag]);
            searchDatasets();
        }
        function toggleBaseUri(base_uri) {
            store.updateBaseUris(store.base_uris.includes(base_uri)
                ? store.base_uris.filter((u) => u !== base_uri)
                : [...store.base_uris, base_uri]);
            searchDatasets();
        }
        function toggleCreator(creator) {
            store.updateCreatorUsernames(store.creator_usernames.includes(creator)
                ? store.creator_usernames.filter((c) => c !== creator)
                : [...store.creator_usernames, creator]);
            searchDatasets();
        }
        function toggleUploader(uploader) {
            store.updateUploadedBy(store.uploaded_by.includes(uploader)
                ? store.uploaded_by.filter((u) => u !== uploader)
                : [...store.uploaded_by, uploader]);
            searchDatasets();
        }
        onMounted(() => {
            load_summary();
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_badge = _resolveComponent("v-badge");
            const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title");
            const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn");
            const _component_v_list_item_title = _resolveComponent("v-list-item-title");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text");
            const _component_v_expansion_panel = _resolveComponent("v-expansion-panel");
            const _component_v_expansion_panels = _resolveComponent("v-expansion-panels");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h6", _hoisted_3, [
                        _createVNode(_component_v_icon, { start: "" }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                    _createTextVNode("mdi-folder-search", -1)
                                ]))]),
                            _: 1
                        }),
                        _cache[3] || (_cache[3] = _createTextVNode(" Repository ", -1))
                    ])
                ]),
                (loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_v_progress_circular, {
                            indeterminate: "",
                            color: "primary"
                        })
                    ]))
                    : (errored.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_v_alert, {
                                type: "error",
                                density: "compact",
                                class: "mb-2"
                            }, {
                                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                        _createTextVNode(" Unable to load summary information please try again. ", -1)
                                    ]))]),
                                _: 1
                            }),
                            _createVNode(_component_v_btn, {
                                size: "small",
                                color: "secondary",
                                onClick: _cache[0] || (_cache[0] = ($event) => (load_summary()))
                            }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                        _createTextVNode(" Try again ", -1)
                                    ]))]),
                                _: 1
                            })
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-body-2 text-grey-darken-1" }, "Total Datasets", -1)),
                                    _createVNode(_component_v_chip, {
                                        size: "small",
                                        color: "primary",
                                        variant: "flat"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(summary_info.value?.number_of_datasets ?? 0), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-body-2 text-grey-darken-1" }, "Filtered", -1)),
                                    _createVNode(_component_v_chip, {
                                        size: "small",
                                        color: "secondary",
                                        variant: "flat"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(store).num_filtered), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _createVNode(_component_v_btn, {
                                    block: "",
                                    variant: "tonal",
                                    color: "primary",
                                    size: "small",
                                    class: "mt-3",
                                    "prepend-icon": "mdi-filter-off",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (clearFilters()))
                                }, {
                                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                            _createTextVNode(" Clear All Filters ", -1)
                                        ]))]),
                                    _: 1
                                })
                            ]),
                            _createVNode(_component_v_expansion_panels, {
                                variant: "accordion",
                                multiple: ""
                            }, {
                                default: _withCtx(() => [
                                    (summary_info.value?.tags && summary_info.value.tags.length > 0)
                                        ? (_openBlock(), _createBlock(_component_v_expansion_panel, { key: 0 }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_expansion_panel_title, { class: "text-body-2 font-weight-medium" }, {
                                                    actions: _withCtx(({ expanded }) => [
                                                        (_unref(store).tags.length > 0)
                                                            ? (_openBlock(), _createBlock(_component_v_badge, {
                                                                key: 0,
                                                                content: _unref(store).tags.length,
                                                                color: "primary",
                                                                inline: "",
                                                                class: "mr-2"
                                                            }, null, 8, ["content"]))
                                                            : _createCommentVNode("", true),
                                                        _createVNode(_component_v_icon, {
                                                            icon: expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
                                                        }, null, 8, ["icon"])
                                                    ]),
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                            start: "",
                                                            size: "small"
                                                        }, {
                                                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                                                    _createTextVNode("mdi-tag-multiple", -1)
                                                                ]))]),
                                                            _: 1
                                                        }),
                                                        _cache[10] || (_cache[10] = _createTextVNode(" Tags ", -1))
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_expansion_panel_text, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_list, {
                                                            density: "compact",
                                                            class: "py-0",
                                                            "max-height": "200",
                                                            style: { "overflow-y": "auto" }
                                                        }, {
                                                            default: _withCtx(() => [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary_info.value.tags, (tag, index) => {
                                                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                                                        key: index,
                                                                        onClick: ($event) => (toggleTag(tag)),
                                                                        class: "px-0"
                                                                    }, {
                                                                        prepend: _withCtx(() => [
                                                                            _createVNode(_component_v_checkbox_btn, {
                                                                                "model-value": _unref(store).tags.includes(tag),
                                                                                density: "compact",
                                                                                "hide-details": "",
                                                                                onClick: _withModifiers(($event) => (toggleTag(tag)), ["stop"])
                                                                            }, null, 8, ["model-value", "onClick"])
                                                                        ]),
                                                                        append: _withCtx(() => [
                                                                            _createVNode(_component_v_chip, {
                                                                                size: "x-small",
                                                                                color: "grey-lighten-1",
                                                                                variant: "flat"
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(summary_info.value.datasets_per_tag[tag]), 1)
                                                                                ]),
                                                                                _: 2
                                                                            }, 1024)
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_v_list_item_title, { class: "text-body-2" }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(tag), 1)
                                                                                ]),
                                                                                _: 2
                                                                            }, 1024)
                                                                        ]),
                                                                        _: 2
                                                                    }, 1032, ["onClick"]));
                                                                }), 128))
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    (summary_info.value?.base_uris && summary_info.value.base_uris.length > 0)
                                        ? (_openBlock(), _createBlock(_component_v_expansion_panel, { key: 1 }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_expansion_panel_title, { class: "text-body-2 font-weight-medium" }, {
                                                    actions: _withCtx(({ expanded }) => [
                                                        (_unref(store).base_uris.length > 0)
                                                            ? (_openBlock(), _createBlock(_component_v_badge, {
                                                                key: 0,
                                                                content: _unref(store).base_uris.length,
                                                                color: "primary",
                                                                inline: "",
                                                                class: "mr-2"
                                                            }, null, 8, ["content"]))
                                                            : _createCommentVNode("", true),
                                                        _createVNode(_component_v_icon, {
                                                            icon: expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
                                                        }, null, 8, ["icon"])
                                                    ]),
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                            start: "",
                                                            size: "small"
                                                        }, {
                                                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                                    _createTextVNode("mdi-folder-marker", -1)
                                                                ]))]),
                                                            _: 1
                                                        }),
                                                        _cache[12] || (_cache[12] = _createTextVNode(" Locations ", -1))
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_expansion_panel_text, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_list, {
                                                            density: "compact",
                                                            class: "py-0",
                                                            "max-height": "200",
                                                            style: { "overflow-y": "auto" }
                                                        }, {
                                                            default: _withCtx(() => [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary_info.value.base_uris, (base_uri, index) => {
                                                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                                                        key: index,
                                                                        onClick: ($event) => (toggleBaseUri(base_uri)),
                                                                        class: "px-0"
                                                                    }, {
                                                                        prepend: _withCtx(() => [
                                                                            _createVNode(_component_v_checkbox_btn, {
                                                                                "model-value": _unref(store).base_uris.includes(base_uri),
                                                                                density: "compact",
                                                                                "hide-details": "",
                                                                                onClick: _withModifiers(($event) => (toggleBaseUri(base_uri)), ["stop"])
                                                                            }, null, 8, ["model-value", "onClick"])
                                                                        ]),
                                                                        append: _withCtx(() => [
                                                                            _createVNode(_component_v_chip, {
                                                                                size: "x-small",
                                                                                color: "grey-lighten-1",
                                                                                variant: "flat"
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(summary_info.value.datasets_per_base_uri[base_uri]), 1)
                                                                                ]),
                                                                                _: 2
                                                                            }, 1024)
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_v_list_item_title, {
                                                                                class: "text-body-2 text-truncate",
                                                                                style: { "max-width": "140px" }
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(base_uri), 1)
                                                                                ]),
                                                                                _: 2
                                                                            }, 1024)
                                                                        ]),
                                                                        _: 2
                                                                    }, 1032, ["onClick"]));
                                                                }), 128))
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    (summary_info.value?.creator_usernames &&
                                        summary_info.value.creator_usernames.length > 0)
                                        ? (_openBlock(), _createBlock(_component_v_expansion_panel, { key: 2 }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_expansion_panel_title, { class: "text-body-2 font-weight-medium" }, {
                                                    actions: _withCtx(({ expanded }) => [
                                                        (_unref(store).creator_usernames.length > 0)
                                                            ? (_openBlock(), _createBlock(_component_v_badge, {
                                                                key: 0,
                                                                content: _unref(store).creator_usernames.length,
                                                                color: "primary",
                                                                inline: "",
                                                                class: "mr-2"
                                                            }, null, 8, ["content"]))
                                                            : _createCommentVNode("", true),
                                                        _createVNode(_component_v_icon, {
                                                            icon: expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
                                                        }, null, 8, ["icon"])
                                                    ]),
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                            start: "",
                                                            size: "small"
                                                        }, {
                                                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                                    _createTextVNode("mdi-account-multiple", -1)
                                                                ]))]),
                                                            _: 1
                                                        }),
                                                        _cache[14] || (_cache[14] = _createTextVNode(" Creators ", -1))
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_expansion_panel_text, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_list, {
                                                            density: "compact",
                                                            class: "py-0",
                                                            "max-height": "200",
                                                            style: { "overflow-y": "auto" }
                                                        }, {
                                                            default: _withCtx(() => [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary_info.value.creator_usernames, (creator, index) => {
                                                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                                                        key: index,
                                                                        onClick: ($event) => (toggleCreator(creator)),
                                                                        class: "px-0"
                                                                    }, {
                                                                        prepend: _withCtx(() => [
                                                                            _createVNode(_component_v_checkbox_btn, {
                                                                                "model-value": _unref(store).creator_usernames.includes(creator),
                                                                                density: "compact",
                                                                                "hide-details": "",
                                                                                onClick: _withModifiers(($event) => (toggleCreator(creator)), ["stop"])
                                                                            }, null, 8, ["model-value", "onClick"])
                                                                        ]),
                                                                        append: _withCtx(() => [
                                                                            _createVNode(_component_v_chip, {
                                                                                size: "x-small",
                                                                                color: "grey-lighten-1",
                                                                                variant: "flat"
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(summary_info.value.datasets_per_creator[creator]), 1)
                                                                                ]),
                                                                                _: 2
                                                                            }, 1024)
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_v_list_item_title, { class: "text-body-2" }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(creator), 1)
                                                                                ]),
                                                                                _: 2
                                                                            }, 1024)
                                                                        ]),
                                                                        _: 2
                                                                    }, 1032, ["onClick"]));
                                                                }), 128))
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    (summary_info.value?.uploaders && summary_info.value.uploaders.length > 0)
                                        ? (_openBlock(), _createBlock(_component_v_expansion_panel, { key: 3 }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_expansion_panel_title, { class: "text-body-2 font-weight-medium" }, {
                                                    actions: _withCtx(({ expanded }) => [
                                                        (_unref(store).uploaded_by.length > 0)
                                                            ? (_openBlock(), _createBlock(_component_v_badge, {
                                                                key: 0,
                                                                content: _unref(store).uploaded_by.length,
                                                                color: "primary",
                                                                inline: "",
                                                                class: "mr-2"
                                                            }, null, 8, ["content"]))
                                                            : _createCommentVNode("", true),
                                                        _createVNode(_component_v_icon, {
                                                            icon: expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
                                                        }, null, 8, ["icon"])
                                                    ]),
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                            start: "",
                                                            size: "small"
                                                        }, {
                                                            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                                    _createTextVNode("mdi-account-arrow-up", -1)
                                                                ]))]),
                                                            _: 1
                                                        }),
                                                        _cache[16] || (_cache[16] = _createTextVNode(" Uploaders ", -1))
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_expansion_panel_text, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_list, {
                                                            density: "compact",
                                                            class: "py-0",
                                                            "max-height": "200",
                                                            style: { "overflow-y": "auto" }
                                                        }, {
                                                            default: _withCtx(() => [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary_info.value.uploaders, (uploader, index) => {
                                                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                                                        key: index,
                                                                        onClick: ($event) => (toggleUploader(uploader)),
                                                                        class: "px-0"
                                                                    }, {
                                                                        prepend: _withCtx(() => [
                                                                            _createVNode(_component_v_checkbox_btn, {
                                                                                "model-value": _unref(store).uploaded_by.includes(uploader),
                                                                                density: "compact",
                                                                                "hide-details": "",
                                                                                onClick: _withModifiers(($event) => (toggleUploader(uploader)), ["stop"])
                                                                            }, null, 8, ["model-value", "onClick"])
                                                                        ]),
                                                                        append: _withCtx(() => [
                                                                            _createVNode(_component_v_chip, {
                                                                                size: "x-small",
                                                                                color: "grey-lighten-1",
                                                                                variant: "flat"
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(summary_info.value.datasets_per_uploader?.[uploader]), 1)
                                                                                ]),
                                                                                _: 2
                                                                            }, 1024)
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_v_list_item_title, { class: "text-body-2" }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(uploader), 1)
                                                                                ]),
                                                                                _: 2
                                                                            }, 1024)
                                                                        ]),
                                                                        _: 2
                                                                    }, 1032, ["onClick"]));
                                                                }), 128))
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ]))
            ]));
        };
    }
});
